import { Stack } from "@mui/material";
import { PersonnelValidationScreen } from "components/authorization";
import { PageTitle } from "components/shared";
import i18n from "../../i18n";

const PersonnelValidation = () => {
  return (
    <Stack spacing={2}>
      <PageTitle title={i18n.t("menu.personalValidation")} />
      <PersonnelValidationScreen />
    </Stack>
  );
};

export default PersonnelValidation;
